import {Component} from "react";
import EnterpriseComponent from "../ec/EnterpriseComponent";

class Applet extends Component {
    constructor(props) {
        super(props);

        this.numberOfPages = null;
        this.titleAttribute = null;
    };

    cancel() {
        if (this.getEnterpriseComponent().isNewMode()) {
            this.setAction("View");
            this.getEnterpriseComponent().executeInsertRollback();
        } else if (this.getEnterpriseComponent().isUpdateMode()) {
            this.setAction("View");
            this.getEnterpriseComponent().executeUpdateRollback();
        } else if (this.getEnterpriseComponent().isDeleteMode()) {
            this.setAction("View");
        } else if (this.getEnterpriseComponent().isQueryMode()) {
            this.getEnterpriseComponent().executeQueryRollback();
        } else if (this.getEnterpriseComponent().isViewMode()) {
            this.getEnterpriseComponent().executeUpdateRollback();
            this.getEnterpriseComponent().executeInsertRollback();
        }
    };

    getEnterpriseComponent = () => {
        return this.props.enterpriseComponent;
    };

    getName = () => {
        if (this.state === null) {
            return "";
        }
        return this.state.Name;
    };

    getSelectedRecordNumber = () => {
        return this.getEnterpriseComponent().getSelectedRecordNumber();
    };

    getTitle = () => {
        if (this.getEnterpriseComponent().getSelectedRecordNumber() !== -1) {
            return this.getEnterpriseComponent().getBuffer()[this.getSelectedRecordNumber()][this.getTitleAttribute()];
        }
        return null;
    };

    getTitleAttribute = () => {
        return this.titleAttribute;
    };

    isRowcountKnown = () => {
        return this.getEnterpriseComponent().getTotalRowcount() !== null;
    };

    refreshRecordHandler = () => {
        this.getEnterpriseComponent().executeSingleRecordRefresh();
    };

    refreshHandler = () => {
    };

    save() {
        if (this.getEnterpriseComponent().isNewMode()) {
            this.getEnterpriseComponent().executeInsert();
            this.setState({action: "Save"});
        } else if (this.getEnterpriseComponent().isUpdateMode()) {
            this.getEnterpriseComponent().executeUpdate();
            this.setState({action: "Save"});
        } else if (this.getEnterpriseComponent().isDeleteMode()) {
            this.getEnterpriseComponent().executeDelete();
            this.setState({action: "Save"});
        } else if (this.getEnterpriseComponent().isQueryMode()) {
            this.getEnterpriseComponent().executeQuery(0, 5);
        }
    };

    setAction(action) {
        this.setState({action: action})

        if (action === "New") {
            if (this.getEnterpriseComponent().getMode() !== EnterpriseComponent.MODE_NEW) {
                this.getEnterpriseComponent().newRecord();
            }
        } else if (action === "Edit") {
            if (this.getEnterpriseComponent().getMode() !== EnterpriseComponent.MODE_UPDATE) {
                this.getEnterpriseComponent().editRecord();
            }
        } else if (action === "Query") {
            if (this.getEnterpriseComponent().getMode() !== EnterpriseComponent.MODE_QUERY) {
                this.getEnterpriseComponent().newQuery();
            }
        } else if (action === "Delete") {
            if (this.getEnterpriseComponent().getMode() !== EnterpriseComponent.MODE_DELETE) {
                this.getEnterpriseComponent().newDelete();
            }
        } else if (action === "Save Completed") {
        }
    };

    unmountComponent = (obj) => {
        this.getEnterpriseComponent().removeAllListeners(obj);
    };
}

export default Applet;
